export default __webpack_public_path__ + "static/question-7f65b8bc2758381f014596c768881e7b.svg";